import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { SeoPageLayout } from '@/components/layout/SeoPageLayout';
import { Link } from '@/components/links';
import { Button, FAQs, Image, OrderedList, Paragraph, SemiBold, SubHeader, UnorderedList } from '@/components/seo';
import { LINKS } from '@/constants/links';
import { NumericRange } from '@/types/range';
import { getIntlProps, type IntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import EshopBoxes from '@/components/boxes/EshopBox/EshopBoxes';
import { isAllowedRoute } from '@/lang/pagesConfig';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
interface Props extends IntlProps {
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(t0) {
  const $ = _c(167);
  const {
    menuPromoBanners
  } = t0;
  usePageView("seo-deferred-payment");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["seoDeferredPayment", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== t) {
    t2 = Array.from({
      length: 2
    }, (_, index) => {
      const faqIndex = index + 1 as NumericRange<1, 2>;
      return {
        question: t(`seoDeferredPayment:sections.faqs.${faqIndex}.question`),
        answer: t(`seoDeferredPayment:sections.faqs.${faqIndex}.answer`)
      };
    });
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const faqsData = t2;
  let t3;
  if ($[3] !== t) {
    t3 = t("seoDeferredPayment:seo.title");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("seoDeferredPayment:seo.description");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = {
      title: t3,
      description: t4
    };
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <br />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  let t8;
  if ($[11] !== t) {
    t7 = <Trans t={t} i18nKey="seoDeferredPayment:header.title">{t6}</Trans>;
    t8 = t("seoDeferredPayment:header.intro");
    $[11] = t;
    $[12] = t7;
    $[13] = t8;
  } else {
    t7 = $[12];
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <p>{t8}</p>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t) {
    t10 = t("seoDeferredPayment:header.button");
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = LINKS();
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10) {
    t12 = {
      label: t10,
      to: t11.registration
    };
    $[19] = t10;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  let t14;
  if ($[21] !== t) {
    t13 = <Trans t={t} i18nKey="seoDeferredPayment:sections.1.content" />;
    t14 = t("seoDeferredPayment:sections.1.title");
    $[21] = t;
    $[22] = t13;
    $[23] = t14;
  } else {
    t13 = $[22];
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t13 || $[25] !== t14) {
    t15 = {
      content: t13,
      title: t14
    };
    $[24] = t13;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      paragraph: <Paragraph />
    };
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t) {
    t17 = <Trans i18nKey="seoDeferredPayment:sections.2.content" t={t} components={t16} />;
    $[28] = t;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = [...Array(2)];
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== t) {
    t19 = <UnorderedList items={t18.map((__0, i) => {
      const transIndex = i + 1 as NumericRange<1, 2>;
      return <Trans key={i} t={t} i18nKey={`seoDeferredPayment:sections.2.list.${transIndex}`} />;
    })} />;
    $[31] = t;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== t) {
    t20 = t("seoDeferredPayment:sections.2.title");
    $[33] = t;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t20) {
    t21 = <Image src="/images/sections/seoDeferredPayment/cs/advantages.png" width={768} height={325} alt={t20} isRounded={true} cropHeight="md" />;
    $[35] = t20;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== t17 || $[38] !== t19 || $[39] !== t21) {
    t22 = <>{t17}{t19}{t21}</>;
    $[37] = t17;
    $[38] = t19;
    $[39] = t21;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== t) {
    t23 = t("seoDeferredPayment:sections.2.title");
    $[41] = t;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] !== t22 || $[44] !== t23) {
    t24 = {
      content: t22,
      title: t23
    };
    $[43] = t22;
    $[44] = t23;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] !== t) {
    t25 = t("seoDeferredPayment:sections.3.title");
    $[46] = t;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = [...Array(7)];
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  let t27;
  if ($[49] !== t) {
    t27 = <OrderedList items={t26.map((__1, i_0) => {
      const transIndex_0 = i_0 + 1 as NumericRange<1, 7>;
      return <Trans key={i_0} t={t} i18nKey={`seoDeferredPayment:sections.3.list.${transIndex_0}`} components={{
        semibold: <SemiBold />,
        paragraph: <Paragraph />
      }} />;
    })} />;
    $[49] = t;
    $[50] = t27;
  } else {
    t27 = $[50];
  }
  let t28;
  if ($[51] !== t25 || $[52] !== t27) {
    t28 = {
      title: t25,
      content: t27
    };
    $[51] = t25;
    $[52] = t27;
    $[53] = t28;
  } else {
    t28 = $[53];
  }
  let t29;
  if ($[54] !== t) {
    t29 = t("seoDeferredPayment:sections.4.title");
    $[54] = t;
    $[55] = t29;
  } else {
    t29 = $[55];
  }
  let t30;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = {
      semibold: <SemiBold />,
      paragraph: <Paragraph />
    };
    $[56] = t30;
  } else {
    t30 = $[56];
  }
  let t31;
  if ($[57] !== t) {
    t31 = <Trans t={t} i18nKey="seoDeferredPayment:sections.4.content1" components={t30} />;
    $[57] = t;
    $[58] = t31;
  } else {
    t31 = $[58];
  }
  let t32;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = {
      subheader: <SubHeader />
    };
    $[59] = t32;
  } else {
    t32 = $[59];
  }
  let t33;
  if ($[60] !== t) {
    t33 = <Trans t={t} i18nKey="seoDeferredPayment:sections.4.subtitle" components={t32} />;
    $[60] = t;
    $[61] = t33;
  } else {
    t33 = $[61];
  }
  let t34;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = [...Array(5)];
    $[62] = t34;
  } else {
    t34 = $[62];
  }
  let t35;
  if ($[63] !== t) {
    t35 = <OrderedList items={t34.map((__2, i_1) => {
      const transIndex_1 = i_1 + 1 as NumericRange<1, 5>;
      return <Trans key={i_1} t={t} i18nKey={`seoDeferredPayment:sections.4.list.${transIndex_1}`} />;
    })} className="mt-2 mb-8" />;
    $[63] = t;
    $[64] = t35;
  } else {
    t35 = $[64];
  }
  let t36;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = {
      semibold: <SemiBold />,
      paragraph: <Paragraph />
    };
    $[65] = t36;
  } else {
    t36 = $[65];
  }
  let t37;
  if ($[66] !== t) {
    t37 = <Trans t={t} i18nKey="seoDeferredPayment:sections.4.content2" components={t36} />;
    $[66] = t;
    $[67] = t37;
  } else {
    t37 = $[67];
  }
  let t38;
  if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = LINKS();
    $[68] = t38;
  } else {
    t38 = $[68];
  }
  const t39 = t38.registration;
  let t40;
  if ($[69] !== t) {
    t40 = t("seoDeferredPayment:sections.4.button");
    $[69] = t;
    $[70] = t40;
  } else {
    t40 = $[70];
  }
  let t41;
  if ($[71] !== t40) {
    t41 = <Button analyticsParam="seoDeferredPaymentRegistration" testId="seoDeferredPaymentRegistration" to={t39} variant="primary" className="mb-8">{t40}</Button>;
    $[71] = t40;
    $[72] = t41;
  } else {
    t41 = $[72];
  }
  let t42;
  if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = {
      semibold: <SemiBold />,
      paragraph: <Paragraph />
    };
    $[73] = t42;
  } else {
    t42 = $[73];
  }
  let t43;
  if ($[74] !== t) {
    t43 = <Trans t={t} i18nKey="seoDeferredPayment:sections.4.content3" components={t42} />;
    $[74] = t;
    $[75] = t43;
  } else {
    t43 = $[75];
  }
  let t44;
  if ($[76] !== t31 || $[77] !== t33 || $[78] !== t35 || $[79] !== t37 || $[80] !== t41 || $[81] !== t43) {
    t44 = <>{t31}{t33}{t35}{t37}{t41}{t43}</>;
    $[76] = t31;
    $[77] = t33;
    $[78] = t35;
    $[79] = t37;
    $[80] = t41;
    $[81] = t43;
    $[82] = t44;
  } else {
    t44 = $[82];
  }
  let t45;
  if ($[83] !== t29 || $[84] !== t44) {
    t45 = {
      title: t29,
      content: t44
    };
    $[83] = t29;
    $[84] = t44;
    $[85] = t45;
  } else {
    t45 = $[85];
  }
  let t46;
  if ($[86] !== t) {
    t46 = t("seoDeferredPayment:sections.5.title");
    $[86] = t;
    $[87] = t46;
  } else {
    t46 = $[87];
  }
  let t47;
  let t48;
  if ($[88] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = <SemiBold />;
    t48 = <Paragraph />;
    $[88] = t47;
    $[89] = t48;
  } else {
    t47 = $[88];
    t48 = $[89];
  }
  let t49;
  if ($[90] === Symbol.for("react.memo_cache_sentinel")) {
    t49 = {
      semibold: t47,
      paragraph: t48,
      link1: <Link analyticsParam="deferredPaymentHintSkipCard" testId="deferredPaymentHintSkipCard" to={LINKS().card} />
    };
    $[90] = t49;
  } else {
    t49 = $[90];
  }
  let t50;
  if ($[91] !== t) {
    t50 = <Trans t={t} i18nKey="seoDeferredPayment:sections.5.content" components={t49} />;
    $[91] = t;
    $[92] = t50;
  } else {
    t50 = $[92];
  }
  let t51;
  if ($[93] !== t46 || $[94] !== t50) {
    t51 = {
      title: t46,
      content: t50
    };
    $[93] = t46;
    $[94] = t50;
    $[95] = t51;
  } else {
    t51 = $[95];
  }
  let t52;
  if ($[96] !== t) {
    t52 = t("seoDeferredPayment:sections.7.title");
    $[96] = t;
    $[97] = t52;
  } else {
    t52 = $[97];
  }
  let t53;
  if ($[98] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = {
      semibold: <SemiBold />,
      paragraph: <Paragraph />
    };
    $[98] = t53;
  } else {
    t53 = $[98];
  }
  let t54;
  if ($[99] !== t) {
    t54 = <Trans t={t} i18nKey="seoDeferredPayment:sections.7.content" components={t53} />;
    $[99] = t;
    $[100] = t54;
  } else {
    t54 = $[100];
  }
  let t55;
  if ($[101] !== t52 || $[102] !== t54) {
    t55 = {
      title: t52,
      content: t54
    };
    $[101] = t52;
    $[102] = t54;
    $[103] = t55;
  } else {
    t55 = $[103];
  }
  let t56;
  if ($[104] !== t) {
    t56 = t("seoDeferredPayment:sections.8.title");
    $[104] = t;
    $[105] = t56;
  } else {
    t56 = $[105];
  }
  let t57;
  if ($[106] === Symbol.for("react.memo_cache_sentinel")) {
    t57 = {
      paragraph: <Paragraph />
    };
    $[106] = t57;
  } else {
    t57 = $[106];
  }
  let t58;
  if ($[107] !== t) {
    t58 = <Trans t={t} i18nKey="seoDeferredPayment:sections.8.content" components={t57} />;
    $[107] = t;
    $[108] = t58;
  } else {
    t58 = $[108];
  }
  let t59;
  if ($[109] === Symbol.for("react.memo_cache_sentinel")) {
    t59 = {
      link: "https://www.mall.cz/",
      image: {
        size: "contain",
        title: "Mall",
        url: "/images/sections/seoDeferredPayment/cs/mallcz_logo.png",
        width: 101,
        height: 20
      },
      size: "sm",
      index: 0,
      section: "seoDeferredPayment"
    };
    $[109] = t59;
  } else {
    t59 = $[109];
  }
  let t60;
  if ($[110] === Symbol.for("react.memo_cache_sentinel")) {
    t60 = {
      link: "https://www.czc.cz/",
      image: {
        size: "contain",
        title: "Czc",
        url: "/images/sections/seoDeferredPayment/cs/czc_logo.png",
        width: 100,
        height: 22
      },
      size: "sm",
      index: 1,
      section: "seoDeferredPayment"
    };
    $[110] = t60;
  } else {
    t60 = $[110];
  }
  let t61;
  if ($[111] === Symbol.for("react.memo_cache_sentinel")) {
    t61 = {
      link: "https://www.parfemy.cz/",
      image: {
        size: "contain",
        title: "Parfemy",
        url: "/images/sections/seoDeferredPayment/cs/parfemy_logo.png",
        width: 112,
        height: 64
      },
      size: "sm",
      index: 2,
      section: "seoDeferredPayment"
    };
    $[111] = t61;
  } else {
    t61 = $[111];
  }
  let t62;
  if ($[112] === Symbol.for("react.memo_cache_sentinel")) {
    t62 = {
      link: "https://www.vivantis.cz/",
      image: {
        size: "contain",
        title: "Vivantis",
        url: "/images/sections/seoDeferredPayment/cs/vivantis_logo.png",
        width: 101,
        height: 22
      },
      size: "sm",
      index: 3,
      section: "seoDeferredPayment"
    };
    $[112] = t62;
  } else {
    t62 = $[112];
  }
  let t63;
  if ($[113] === Symbol.for("react.memo_cache_sentinel")) {
    t63 = <EshopBoxes eshops={[t59, t60, t61, t62, {
      link: "https://www.slevomat.cz/",
      image: {
        size: "contain",
        title: "Slevomat",
        url: "/images/sections/seoDeferredPayment/cs/slevomat_logo.png",
        width: 105,
        height: 25
      },
      size: "sm",
      index: 4,
      section: "seoDeferredPayment"
    }]} boxSize="sm" className="mb-6 justify-center lg:mb-8 lg:justify-start" />;
    $[113] = t63;
  } else {
    t63 = $[113];
  }
  let t64;
  if ($[114] === Symbol.for("react.memo_cache_sentinel")) {
    t64 = LINKS();
    $[114] = t64;
  } else {
    t64 = $[114];
  }
  const t65 = t64.whereToShop;
  let t66;
  if ($[115] !== t) {
    t66 = t("seoDeferredPayment:sections.8.button");
    $[115] = t;
    $[116] = t66;
  } else {
    t66 = $[116];
  }
  let t67;
  if ($[117] !== t66) {
    t67 = <Button analyticsParam="deferredPaymentShowAllEshops" testId="deferredPaymentShowAllEshops" to={t65} variant="secondary">{t66}</Button>;
    $[117] = t66;
    $[118] = t67;
  } else {
    t67 = $[118];
  }
  let t68;
  if ($[119] !== t58 || $[120] !== t67) {
    t68 = <>{t58}{t63}{t67}</>;
    $[119] = t58;
    $[120] = t67;
    $[121] = t68;
  } else {
    t68 = $[121];
  }
  let t69;
  if ($[122] !== t56 || $[123] !== t68) {
    t69 = {
      title: t56,
      content: t68
    };
    $[122] = t56;
    $[123] = t68;
    $[124] = t69;
  } else {
    t69 = $[124];
  }
  let t70;
  if ($[125] !== t) {
    t70 = t("seoDeferredPayment:sections.9.title");
    $[125] = t;
    $[126] = t70;
  } else {
    t70 = $[126];
  }
  let t71;
  if ($[127] === Symbol.for("react.memo_cache_sentinel")) {
    t71 = {
      semibold: <SemiBold />,
      paragraph: <Paragraph />
    };
    $[127] = t71;
  } else {
    t71 = $[127];
  }
  let t72;
  if ($[128] !== t) {
    t72 = <Trans t={t} i18nKey="seoDeferredPayment:sections.9.content" components={t71} />;
    $[128] = t;
    $[129] = t72;
  } else {
    t72 = $[129];
  }
  let t73;
  if ($[130] === Symbol.for("react.memo_cache_sentinel")) {
    t73 = {
      subheader: <SubHeader />
    };
    $[130] = t73;
  } else {
    t73 = $[130];
  }
  let t74;
  if ($[131] !== t) {
    t74 = <Trans t={t} i18nKey="seoDeferredPayment:sections.9.subtitle" components={t73} />;
    $[131] = t;
    $[132] = t74;
  } else {
    t74 = $[132];
  }
  let t75;
  if ($[133] === Symbol.for("react.memo_cache_sentinel")) {
    t75 = [...Array(3)];
    $[133] = t75;
  } else {
    t75 = $[133];
  }
  let t76;
  if ($[134] !== t) {
    t76 = <UnorderedList items={t75.map((__3, i_2) => {
      const transIndex_2 = i_2 + 1 as NumericRange<1, 3>;
      return <Trans key={i_2} t={t} i18nKey={`seoDeferredPayment:sections.9.list.${transIndex_2}`} />;
    })} />;
    $[134] = t;
    $[135] = t76;
  } else {
    t76 = $[135];
  }
  let t77;
  if ($[136] !== t72 || $[137] !== t74 || $[138] !== t76) {
    t77 = <>{t72}{t74}{t76}</>;
    $[136] = t72;
    $[137] = t74;
    $[138] = t76;
    $[139] = t77;
  } else {
    t77 = $[139];
  }
  let t78;
  if ($[140] !== t70 || $[141] !== t77) {
    t78 = {
      title: t70,
      content: t77
    };
    $[140] = t70;
    $[141] = t77;
    $[142] = t78;
  } else {
    t78 = $[142];
  }
  let t79;
  if ($[143] !== t) {
    t79 = t("core:faqs.title");
    $[143] = t;
    $[144] = t79;
  } else {
    t79 = $[144];
  }
  let t80;
  if ($[145] !== faqsData) {
    t80 = <FAQs data={faqsData} />;
    $[145] = faqsData;
    $[146] = t80;
  } else {
    t80 = $[146];
  }
  let t81;
  if ($[147] !== t79 || $[148] !== t80) {
    t81 = {
      title: t79,
      content: t80
    };
    $[147] = t79;
    $[148] = t80;
    $[149] = t81;
  } else {
    t81 = $[149];
  }
  let t82;
  if ($[150] !== t15 || $[151] !== t24 || $[152] !== t28 || $[153] !== t45 || $[154] !== t51 || $[155] !== t55 || $[156] !== t69 || $[157] !== t78 || $[158] !== t81) {
    t82 = [t15, t24, t28, t45, t51, t55, t69, t78, t81];
    $[150] = t15;
    $[151] = t24;
    $[152] = t28;
    $[153] = t45;
    $[154] = t51;
    $[155] = t55;
    $[156] = t69;
    $[157] = t78;
    $[158] = t81;
    $[159] = t82;
  } else {
    t82 = $[159];
  }
  let t83;
  if ($[160] !== menuPromoBanners || $[161] !== t12 || $[162] !== t5 || $[163] !== t7 || $[164] !== t82 || $[165] !== t9) {
    t83 = <SeoPageLayout menuPromoBanners={menuPromoBanners} seo={t5} title={t7} intro={t9} introButton={t12} sections={t82} />;
    $[160] = menuPromoBanners;
    $[161] = t12;
    $[162] = t5;
    $[163] = t7;
    $[164] = t82;
    $[165] = t9;
    $[166] = t83;
  } else {
    t83 = $[166];
  }
  return t83;
}
export const getStaticProps: GetStaticProps = async ctx => {
  const isAllowed = isAllowedRoute('odlozena-platba');
  if (!isAllowed) {
    return {
      notFound: true
    };
  }
  return {
    props: {
      menuPromoBanners: await getAllPageMenuPromoBanners(),
      ...(await getIntlProps(ctx, ['core', 'seoDeferredPayment']))
    }
  };
};